export default (theme) => {
    return {
        toolbar: {
            backgroundColor: theme.colors.primary.white,
            display: 'flex',
            flexFlow: 'row nowrap',
            alignItems: 'center',
            gap: 4,
            padding: 8,
        },
        floatingToolbar: {
            position: 'relative',
            padding: 6,
            backgroundColor: theme.colors.grey[700],
            borderRadius: 2,
            display: 'flex',
            flexFlow: 'row nowrap',
            gap: 4,
        },
        toolbarItems: {
            display: 'flex',
            flexFlow: 'row nowrap',
            alignItems: 'center',
            gap: 4,
            '& > span': {
                width: 18,
                height: 18,
            },
        },
        toolbarItem: {
            boxSizing: 'border-box',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'transparent',
            border: 'none',
            borderRadius: 2,
            padding: 1,
            cursor: 'pointer',
            transition: 'all .2s ease',
            width: 18,
            height: 18,
            fontSize: 16,
            '& [class*="Icon"], & svg': {
                width: '1em !important',
                height: '1em !important',
            },
            '&:hover': {
                backgroundColor: theme.colors.grey[100],
            },
        },
        toolbarItemActive: {
            backgroundColor: theme.colors.grey[100],
        },
        floatingToolbarItem: {
            '&:hover': {
                backgroundColor: theme.colors.utility.textSecondary,
            },
        },
        floatingToolbarItemActive: {
            backgroundColor: theme.colors.utility.textSecondary,
        },
        toolbarDivider: {
            width: 1,
            height: 20,
            backgroundColor: theme.colors.utility.textSecondary,
            margin: '0 2px',
        },
        toolbarCustomActions: {
            display: 'flex',
            flexFlow: 'row nowrap',
            marginLeft: 'auto',
            gap: 8,
        },
        submitIcon: {
            cursor: 'pointer',
        },
        basicSubmit: {
            margin: '5px 12px 8px 8px',
            backgroundColor: theme.colors.primary.white,
            borderRadius: 50,
            width: 24,
            height: 24,
            '& span': {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            },
            '& svg': {
                height: 17,
                width: 17,
            },
            '&$basicSubmitClickable': {
                backgroundColor: theme.colors.actionMajor[500],
                '&:hover': {
                    backgroundColor: theme.colors.actionMajor[600],
                },
            },
        },
        basicSubmitClickable: {},
        basicLoader: {
            margin: '6px 16px 12px 8px',
        },
        compactMode: {
            backgroundColor: 'transparent',
            position: 'absolute',
            bottom: 0,
            right: 0,
            padding: '3px 12px',
            width: '100%',
            boxSizing: 'border-box',
            justifyContent: 'space-between',
            pointerEvents: 'none',
            '& $toolbarDivider': {
                width: 1,
                height: 20,
                backgroundColor: theme.colors.utility.textSecondary,
                margin: '0 2px',
            },
            '& $toolbarItems': {
                opacity: 0,
            },
        },
        compactModeFocused: {
            backgroundColor: 'transparent',
            position: 'absolute',
            bottom: 0,
            right: 0,
            padding: '3px 12px',
            width: '100%',
            boxSizing: 'border-box',
            justifyContent: 'space-between',
            pointerEvents: 'auto',
            '& $toolbarDivider': {
                width: 1,
                height: 20,
                backgroundColor: theme.colors.utility.textSecondary,
                margin: '0 2px',
            },
            '& $toolbarItems': {
                opacity: 1,
            },
            '& > span': {
                display: 'inherit',
            },
        },
    };
};
